import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
import { Typography, Grid, Stack, Button, Autocomplete } from "@mui/material";
import { InputAdornment, Box, styled, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AmountSection from "./AmountSection";
import { useDispatch, useSelector } from "react-redux";
import { getItems ,} from "../inventory/itemsSlice";
import { getStockReport } from "./httpCalls";
const DateBookRepository = RepositoryFactory.get("datebook_repository");
import  {Print}  from "./Print";
import  PrintBill  from "./PrintBill";
import { StockPrint } from "./StockPrint";
import { ExpensePrint } from "./ExpensePrint";
import { PurchasePrint } from "./PurchasePrint";
import { PurchaseReturnPrint } from "./PurchaseReturnPrint";
import { getVendors } from "../vendors/vendorSlice";
import BillsRepository from "../../Repository/BillsRepository";
import { getCombinedSales, getRangeSales, getSalesProfit ,loadBills} from "./httpCalls";
import { getBills} from "../bills/httpCalls";
import ChallanPrint from "./ChallanPrint";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import GatPassPrint from "./GatPassPrint";
import { getVehicleReport } from "../vehicles/vehicleReportSlice";
import MyAutoComplete from "../components/MyAutoComplete";
import { getVehicles } from "../vehicles/vehicleSlice";
import Sales from "./tables/Sales";
import Purchase from "./tables/Purchase";
import Expense from "./tables/Expense";
import Stock from "./tables/Stock";
import PurchaseReturn from "./tables/PurchaseReturn";
import GatePass from "./tables/GatePass";
import CustomerSale from "./tables/CustomerSale";
import PaymentReport from "./tables/PaymentReport";
import SalesByEmployee from "./tables/SalesByEmployee";
import BanksDetails from "./tables/BanksDetails";

import SupplierPurchase from "./tables/SupplierPurchase";
import Loader from "../components/Loader";
import ButtonsList from "./ButtonsList";
import VExpense from "./tables/VehicleExpense";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import Repo from "../../Repository/Repo";
import CombinedSale from "./tables/CombinedSale";
import ProfitLoss from "./tables/ProfitLoss";
import { useReactToPrint } from "react-to-print";
import BalanceSheet from "./tables/BalanceSheet";
import { BalanceSheetPrint } from "./BalanceSheetPrint";
import { HeaderBtn, HeaderTitle } from "../../pages/bank/styles";
import { BodyContainer, Header } from "../../pages/bank/styles";
import { SupplierPurchasePrint } from "./SupplierPurchasePrint";
import { CustomerSalesPrint  } from "./CustomerSalesPrint";
import { CombinedSalesPrint } from "./CombinedSalesPrint";
import { SalesReturnPrint } from "./SalesReturnPrint";
import { PaymentPrint  } from "./PaymentPrint";
import { SalesByEmployeePrint  } from "./SalesByEmployeePrint";
import { BanksReportPrint  } from "./BanksReportPrint";


import UserRepository from "../../Repository/UserRepository";
import CustomerPurchasePrintReport from "./CustomerPurchasePrintReport";
import SupplierSalesPrintReport from "./SupplierSalesPrintReport";


function Reports() {
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  const printRef = useRef(null);
  const { purchaseLedgers, purchaseRemaining, saleLedgers, saleRemaining } =
    useSelector((state) => state.balanceSheet);
  const { vehicleReports } = useSelector((state) => state.vehicleReport);
  const { vehicles } = useSelector((state) => state.vehicle);
  const { items, totalStockValue } = useSelector((state) => state.inventory);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const vendors = useSelector((state) => state.vendor.vendors);
  const [token, setToken] = useState("");
  const [datebook, setDatebook] = useState([]);
  const [mode, setMode] = useState(companyCode == 4416 ? "expense" : "sales");
  const [printSheet, setPrintSheet] = useState(false);
  const [data, setData] = useState({});
  const [paymentType, setPaymentType] = useState(["cash","bank"]);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [stockReport, setStockReport] = useState([]);


  const [employees, setEmployees] = useState([]);
const [employeesReport,setEmployeesReport] = useState([]);
const [employeesReportTotalSales,setEmployeesReportTotalSales] = useState(0);
console.log(employeesReportTotalSales,"employeesReportTotalSales");


console.log(employeesReport,"emmmployess");
const [selectedEmployee,setSelectedEmployee] = useState("");
const [selectedBank,setSelectedBank] = useState("");

const [banks, setBanks] = useState([]);
console.log('banks',banks)

console.log('selectedEmployee',selectedEmployee)
console.log('log',employees)
console.log('emp',selectedEmployee)

  const [search, setSearch] = useState({
    startDate: "",
    endDate: "",
    itemName: "",
    driverName: "",
    vehicleName: "",
    customerInfo: "",
    ledger: "",
    vendor: "",
  });
  const [selected, setSelected] = useState([]);
  const [state, setState] = useState({
    value: 0,
    credit: 0,
    loading: false,
    moreLoading: false,
    spin_loading: false,
    profit: 0,
    loss: 0,
    totalAmount:0,
    category: "all",
    user_id: "all",
    totalPurchase: 0,
    balance:0,
    totalPayment:0,
    items:[]

  });
  const [vehicleData, setVehicleData] = useState([]);
  console.log('mode', mode);
  console.log('dateBook', datebook);
  useEffect(() => {
    if (companyCode == 4416) {
      expenseReports();
    } else {
      getSales();
    }
   
  }, []);


  useEffect(()=> {
    if ( mode == "employeeReport") {
      getEmployees();
    }
    if ( mode == "banksReport") {
      getBanks();
    }
  },[mode])

  const handleChange = (item) => {
    console.log('item,',item)
    let found = selected.findIndex((i) => i._id == item._id);
    if (found == -1) {
      console.log('if',item)

      selected.push(item);
    } else {
      console.log('else',item)

      selected.splice(found, 1);
    }
  };

  const handleClear = () => {
    setSearch({
      startDate: "",
      endDate: "",
      itemName: "",
      customerInfo: "",
      ledger: "",
      driverName: "",
      vehicleName: "",
    });
  };





  const getGatePassItems = async (start, end) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await Repo.bills({
      request: {
        method: "getItemsSaleReport",
        data: {
          company_code: companyCode,
          itemName: search.itemName,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
        },
      },
    });
    setDatebook(data.response.data.bills);
    setState((prev) => ({
      ...prev,
      loading: false,
      profit: data.response.data?.profit || 0,
    }));
  };

  const handleDriver = (e, val) => {
    if (val) {
      const { driverName } = val;
      setSearch((prev) => ({ ...prev, driverName }));
    } else {
      setSearch((prev) => ({
        ...prev,
        driverName: "",
      }));
    }
  };
  const handleVehicle = (e, val) => {
    if (val) {
      const { vehicleName } = val;
      setSearch((prev) => ({ ...prev, vehicleName }));
    } else {
      setSearch((prev) => ({
        ...prev,
        vehicleName: "",
      }));
    }
  };

  const purchaseReturnReports = async (start, end) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await Repo.purchases({
      request: {
        method: "getReturnPurchasesReportsFilter",
        data: {
          category: state.category != "all" ? state.category : "",
          user_id: state.user_id != "all" ? state.user_id : "",
          company_code: companyCode,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
          all_reports: one && two ? false : true,
        },
      },
    });
    setDatebook(data.response.data.purchases);
    setState({
      credit: data.response.data.credit,
      totalPurchase: data.response.data.totalPurchase,
      loading: false,
    });
  };

  const purchaseReports = async (start, end) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await Repo.purchases({
      request: {
        method: "getPurchaseReportsFilter",
        data: {
          category: "",
          user_id: "",
          company_code: companyCode,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
          all_reports: one && two ? false : true,
        },
      },
    });
    setDatebook(data.response.data.purchases);
    setState((prev) => ({
      ...prev,
      totalPurchase: data.response.data.totalPurchase,
      totalPaid: data.response.data.totalPaid,
      totalRemaining: data.response.data.totalRemaining,
      loading: false,
    }));
  };

  const expenseReports = async (start, end) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await DateBookRepository.expenseModel({
      request: {
        method: "getRangeExpenseByCompany",
        data: {
          company_code: companyCode,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
          all_reports: one && two ? false : true,
        },
      },
    });
    setDatebook(data.response.data.dateBook);
    setState((prev) => ({
      ...prev,
      credit: data.response.data.totalExpense,
      loading: false,
    }));
  };

  const getSupplierPurchase = async (val) => {
    let id = "";
    if (val) {
      id = val;
    } else {
      if (search.ledger) {
        id = search.ledger;
      } else if (search.vendor) {
        id = search.vendor;
      }
    }
    clearFields("loading");

    let { data } = await Repo.purchases({
      request: {
        method: "getSupplierPurchaseReport",
        data: {
          company_code: companyCode,
          supplier_id: id,
          itemName: search.itemName,
          startDate: search.startDate.split("-").reverse().join("-"),
          endDate: search.endDate.split("-").reverse().join("-"),
        },
      },
    });
    setDatebook(data.response.data.purchases);
    setState((prev) => ({
      ...prev,
      totalPurchase: data.response.data.totalPurchase,
      loading: false,
    }));
    setData(data.response.data);
  };
  const salesReturnReports = async (start, end) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await BillsRepository.billsModel({
      request: {
        method: "getReturnBillsReportsFilter",
        data: {
          category: "",
          company_code: companyCode,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
          all_reports: one && two ? false : true,
        },
      },
    });
    setDatebook(data.response.data.bills);
    setState((prev) => ({
      ...prev,
      credit: data.response.data.credit,
      loading: false,
    }));
  };

  const clearFields = (name) => {
    setState((prev) => ({
      ...prev,
      [name]: true,
      totalAmount: "",
      credit: "",
      totalRemaining: "",
      totalPaid: "",
      totalPurchase: "",
      profit: "",
    }));
  };

  const getCustomerSale = async (val, name) => {
    clearFields("loading");
    let { data } = await BillsRepository.billsModel({
      request: {
        method: "getCustomerSaleReport",
        data: {
          company_code: companyCode,
          customer: name ? name : search.customerInfo,
          ledger_id: val ? val : search.ledger ? search.ledger : "",
          itemName: search.itemName,
          startDate: search.startDate.split("-").reverse().join("-"),
          endDate: search.endDate.split("-").reverse().join("-"),
        },
      },
    });
    setDatebook(data.response.data.bills);
    setState((prev) => ({
      ...prev,
      credit: data.response.data.credit,
      debit: data.response.data.debit,
      loading: false,
    }));
    setData(data.response.data);
  };

  const getSalesReportEmployee = async (val, name,start,end) => {
    console.log('valll',val)
    console.log('start',start)
    console.log('end',end)

    clearFields("loading");
    console.log("ssselected",selectedEmployee)
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await Repo.bills({
      request: {
        method: "getBillsByUserId",
        data: {
          company_code: companyCode,
          // userId: val ? val._id : selectedEmployee,
           userId:  val ? val :'',

          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
        },
      },
    });
    console.log('data', data)
    setEmployeesReport(data.response.data.billsArray);
    setEmployeesReportTotalSales(data.response.data.totalSales);
    setState((prev) => ({
      ...prev,
      credit: data.response.data.credit,
      debit: data.response.data.debit,
      loading: false,
    }));
    setData(data.response.data);
  };


  const getBanksReports = async (val, name,start,end) => {
    console.log('valll',val)
    console.log('start',start)
    console.log('end',end)

    clearFields("loading");
    console.log("ssselected",selectedEmployee)
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await Repo.banks({
      request: {
        method: "getBankDetailsByBank",
        data: {
          // company_code: companyCode,
          bankId: val ? val._id : selectedEmployee,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
        },
      },
    });
    console.log('data', data)
    setEmployeesReport(data.response.data.banksDetails);
    setState((prev) => ({
      ...prev,
      credit: data.response.data.totalCredit,
      debit: data.response.data.totalDebit,
      balance: data.response.data.balance,
      loading: false,
    }));
    setData(data.response.data);
  };

  const getPaymentReport = async (val, name,start,end) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { data } = await Repo.payment({
      request: {
        method: "getPaymentsReport",
        data: {
          company_code: companyCode,
          type:val ? val : selectedPaymentType,
          startDate: one ? moment(one).format("DD-MM-YYYY") : "",
          endDate: two ? moment(two).format("DD-MM-YYYY") : "",
        },
      },
    });
    console.log('data', data)
    setDatebook(data.response.data.paymentArr);
    setState((prev) => ({
      ...prev,
      credit: data.response.data.credit,
      debit: data.response.data.debit,
      totalPayment:data.response.data.amountTotal,
      loading: false,
    }));
    setData(data.response.data);
  };


  const getEmployees = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await UserRepository.usersModel({
      request: {
        method: "getEmployees",
        data: {
          company_code: companyCode,
        },
      },
    });
console.log('data', data)
    setEmployees(data.response.data.employees);
  };



  const getBanks = async () => {
    try {
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: companyCode,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        // let total = 0;
        // data.response.data.banks.forEach((i) => {
        //   total += parseInt(i?.balance) || 0;
        // });
        setBanks(data.response.data.banks);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };







  const getSales = async (start, end, noToken) => {
    clearFields("loading");
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    // Promise.all([loadBills(noToken,one,two), getBills(noToken)])

    Promise.all([loadBills(noToken,one,two)])
      .then((res) => {
        console.log('res',res)
        setToken(res[0].data.response.data.next_page_token);
        setDatebook(res[0].data.response.data.items);
        // setData(data.response.data);
        setState((prev) => ({
          ...prev,
          credit: res[0].data.response.data.credit,
          debit: res[0].data.response.data.debit,
          // items: res[1].data.response.data.items,
          // loss: res[1].data.response.data.sales.loss,
          // totalAmount: res[1].data.response.data.sales.total_amount,

          loading: false,
        }));
        console.log('res', res)
      })
      .catch((err) => {
        console.log(err);
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      });
  };
  const getCombined = async (start = "", end = "", noToken) => {
    let getToken = noToken ? "" : token;
    let load = noToken ? "loading" : "moreLoading";
    clearFields(load);

    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    let { response } = await getCombinedSales(one, two, getToken);
    if (response.status.statusCode == 200) {
      setDatebook(response.data.bills);
      setToken(response.data.next_page_token);
      setState((prev) => ({
        ...prev,
        credit: response.data.totalAmount,
        profit: response.data.totalProfit,
        [load]: false,
      }));
    } else {
      console.log(response);
      setState((prev) => ({
        ...prev,
        [load]: false,
      }));
    }
  };
  const getMoreCombined = async () => {
    clearFields("moreLoading");
    let one = search.startDate;
    let two = search.endDate;
    let { response } = await getCombinedSales(one, two, token);
    if (response.status.statusCode == 200) {
      setDatebook(response.data.bills);
      setToken(response.data.next_page_token);
      setState((prev) => ({
        ...prev,
        credit: response.data.totalAmount,
        moreLoading: false,
      }));
    } else {
      console.log(response);
      setState((prev) => ({
        ...prev,
        moreLoading: false,
      }));
    }
  };
  const getMoreSales = async (start, end) => {
    let one = start ? start : search.startDate;
    let two = end ? end : search.endDate;
    setState((prev) => ({
      ...prev,
      moreLoading: true,
    }));
    let res = await getRangeSales(one, two, token);
    // setDatebook((prev) => [...prev, ...res.data.response.data.dateBook]);
    setToken(res.data.response.data.next_page_token);
    setState((prev) => ({
      ...prev,
      credit: res.data.response.data.credit,
      debit: res.data.response.data.debit,
      moreLoading: false,
    }));
  };

  const profitLossPrint = useReactToPrint({
    content: () => printRef.current,
  });


  const convertItemsPrint = (bills="") => {
    console.log('bills', bills)
    console.log('convetItems');
    let col = ["#", "Desciption", "Debit", "Credit", "Created"];
    let copy = selected.length > 0 ? selected : datebook;
    console.log('selected', selected)
    console.log('copy', copy)
    console.log('datebook', datebook)


    console.log('mode', mode);
    if (mode == "sales" && (bills !== "bills" && bills !== "customer" && bills !== "supplier" )) {
      Print({  search, items: copy, state });
    } else if (mode == "stock") {
      let newItems = selected.length > 0 ? selected : items;
      let val = totalStockValue;
      StockPrint({ search, items:  stockReport, state, val });
    } else if (mode == "expense") {
      ExpensePrint({ search, items: copy, state });
    } else if (mode == "purchase") {
      PurchasePrint({ search, items: copy, state });
    } else if (mode == "purchaseReturn") {
      PurchaseReturnPrint({ search, items: copy, state });
    } else if (mode == "gatePass") {
      GatPassPrint({ search, items: copy, state });
    } 
    else if (mode == "supplierPurchase" && bills !== "supplier") {
      SupplierPurchasePrint({ search, items: copy, state });
      console.log('printSupplier');
    } else if (mode == "profitLoss") {
      profitLossPrint();
    } else if (mode == "balanceSheet") {
      BalanceSheetPrint({
        purchaseLedgers,
        purchaseRemaining,
        saleLedgers,
        saleRemaining,
      });
    } 
    else if (mode == "customerSale" && bills !== "customer") {
      CustomerSalesPrint({ data,search, items:{datebook}, state });
    }
    else if (mode == "combinedSales" && bills !== "bills" ) {
      CombinedSalesPrint({ search, items: { datebook }, state });
    }
    else if (mode == "salesReturn" && bills !== "bills" ) {
      SalesReturnPrint({ search, items: { datebook }, state });
    }
    else if (mode == "paymentReport") {
      PaymentPrint({ data,search, items, state ,employees});
    }
    else if (mode == "employeeReport") {
      SalesByEmployeePrint({ data:employeesReport,search, items, state ,employees});
    }
    else if (mode == "banksReport") {
      BanksReportPrint({ data:employeesReport,search, items, state ,employees,selectedBank});
    } else if(mode == "combinedSales" &&  (bills == "bills" && bills !== "customer" && bills !== "supplier" )) {
      PrintBill({  search, items: copy, state });

    } else if(mode == "customerSale" && ( bills == "customer" ) && bills !== "supplier") {
      CustomerPurchasePrintReport({  search, items: copy, state });

    }
    else if(mode == "supplierPurchase" &&  (bills == "supplier" )) {
      SupplierSalesPrintReport({  search, items: copy, state });

    }
  };

  const handleMode = async(name) => {

    console.log("modeee", mode);
    setMode(name);
    setToken("");
    setSelected([]);
    if (name == "sales") {
      getSales("", "", true);
    } else if (name == "combinedSales") {
      getCombined("", "", true);
    } else if (name == "salesReturn") {
      salesReturnReports();
    } else if (name == "expense") {
      expenseReports();
    } else if (name == "purchase") {
      purchaseReports();
    } else if (name == "purchaseReturn") {
      purchaseReturnReports();
    }  
    else if (name == "customerSale") {
      if (ledgersNames.length == 0) {
        dispatch(getLedgersNames());
      }
      if (search.customerInfo || search.itemName || search.ledger) {
        getCustomerSale();
      } else if (search.startDate && search.endDate) {
        getCustomerSale();
      } else {
        setDatebook([]);
        setState((prev) => ({ ...prev, credit: "", debit: "" }));
      }
    } else if (name == "paymentReport") {
      getPaymentReport() 
    } else if (name == "supplierPurchase") {
      if (vendors.length == 0) {
        dispatch(getVendors());
      }
      if (ledgersNames.length == 0) {
        dispatch(getLedgersNames());
      }
      if (search.vendor || search.itemName || search.ledger) {
        getSupplierPurchase();
      } else if (search.startDate && search.endDate) {
        getSupplierPurchase();
      } else {
        setDatebook([]);
      }
    } else if (name == "gatePass") {
      setDatebook([]);
    } else if (name == "stock") {
      if (items.length == 0) {
        dispatch(getItems());
    
      }
      const stockReport = await getStockReport();
      console.log('stockReport', stockReport)
       setStockReport(stockReport.items);
    } else if (name == "vehiclesExpense") {
      if (vehicles.length == 0) {
        dispatch(getVehicles());
      }
      if (vehicleReports.length == 0) {
        dispatch(getVehicleReport());
      }
    }
  };
  const handleDate = (e, name) => {
    setSearch((prev) => ({ ...prev, [name]: e }));
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    console.log('name',name)
    console.log('value',value)
    console.log('va',search.startDate)

    setSearch((prev) => ({ ...prev, [name]: value }));
    if (name == "startDate" && value && search.endDate) {
      if (mode == "sales") {
        getSales(value, search.endDate);
      } else if (mode == "combinedSales") {
        getCombined(value, search.endDate, true);
      } else if (mode == "salesReturn") {
        salesReturnReports(value, search.endDate);
      } else if (mode == "expense") {
        expenseReports(value, search.endDate);
      } else if (mode == "purchase") {
        purchaseReports(value, search.endDate);
      } else if (mode == "purchaseReturn") {
        purchaseReturnReports(value, search.endDate);
      } else if (mode == "gatePass") {
        getGatePassItems(value, search.endDate);
      }
    } else if (name == "endDate" && value && search.startDate) {
      if (mode == "sales") {
        getSales(search.startDate, value);
      } else if (mode == "combinedSales") {
        getCombined(search.startDate, value, true);
      } else if (mode == "salesReturn") {
        salesReturnReports(search.startDate, value);
      } else if (mode == "expense") {
        expenseReports(search.startDate, value);
      } else if (mode == "purchase") {
        purchaseReports(search.startDate, value);
      } else if (mode == "purchaseReturn") {
        purchaseReturnReports(search.startDate, value);
      } else if (mode == "gatePass") {
        getGatePassItems(search.startDate, value);
      } else if (mode == "gatePass") {
        getProfitLoss(search.startDate, value);
      }
      else if (mode == "paymentReport") {
        getPaymentReport("","",search.startDate, value);
      }
      else if (mode == "employeeReport") {
        getSalesReportEmployee("","",search.startDate, value);
      } 
    }
  };
  const handleInput = (e, val = "", arg = "") => {
    console.log('valllllue', val);
    const { name, value } = e.target;
    if (arg == "ledger") {
      if (val) {
        setSearch((prev) => ({
          ...prev,
          ledger: val._id,
          customerInfo: val.name,
          vendor: "",
        }));
        if (mode == "customerSale") {
          getCustomerSale(val._id, val.name);
        } else if (mode == "supplierPurchase") {
          getSupplierPurchase(val._id);
        }
        else if (mode == "paymentReport") {
          getPaymentReport(val);
        }
        else if (mode == "employeeReport") {
          getSalesReportEmployee(val.username);
        }
        else if (mode == "banksReport") {
          getBanksReports(val);
        }
     
      } else {
        setSearch((prev) => ({ ...prev, ledger: "" }));
      }
    } else if (arg == "vendor") {
      if (val) {
        setSearch((prev) => ({ ...prev, [arg]: val, ledger: "" }));
        getSupplierPurchase(val._id);
      } else {
        setSearch((prev) => ({ ...prev, [arg]: "" }));
      }
    } else {
      setSearch((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key == "Enter") {
      if (mode == "customerSale") {
        getCustomerSale();
      } else {
        getSupplierPurchase();
      }
    }
  };
  const printDeliveryChallan = () => {
    let copy = selected.length > 0 ? selected : datebook;
    ChallanPrint({ items: copy, search });
  };

  return (
    <Box>
      <Header>
        <HeaderTitle>Reports</HeaderTitle>
        <Stack spacing="8px" direction="row">
          {(mode == "customerSale" || mode == "supplierPurchase") && (
            <>
               {(mode == "customerSale") &&
                <HeaderBtn
                  disabled={datebook && datebook.length > 0 ? false : true}
                  onClick={()=>convertItemsPrint("customer")}
                >
                  Generate Customer Bills Report
                </HeaderBtn>
              }
              {(mode == "supplierPurchase") &&
                <HeaderBtn
                  disabled={datebook && datebook.length > 0 ? false : true}
                  onClick={()=>convertItemsPrint("supplier")}
                >
                  Generate Supplier Bills Report
                </HeaderBtn>
              }
            <HeaderBtn
              disabled={(datebook && datebook.length > 0 )? false : true}
              onClick={printDeliveryChallan}
            >
              Delivery Challan
            </HeaderBtn>
            </>
          )}
          
      {(mode == "combinedSales") &&
          <HeaderBtn
            disabled={datebook && datebook.length > 0 ? false : true}
            onClick={()=>convertItemsPrint("bills")}
          >
            Generate Bills Report
          </HeaderBtn>
        }
          {(mode !== "employeeReport") &&
          <HeaderBtn
            disabled={(mode == "stock" ? (items && items.length > 0 )  :(datebook && datebook.length > 0 ) ) ? false : true}
            onClick={convertItemsPrint}
          >
            Generate Report
          </HeaderBtn>
        }

        {( mode == "employeeReport") &&
          <HeaderBtn
            disabled={(employeesReport && employeesReport.length > 0 )? false : true}
            onClick={convertItemsPrint}
          >
            Generate Report
          </HeaderBtn>
        }
        </Stack>
      </Header>

      <BodyContainer>
        <ButtonsList mode={mode} btnClick={(i) => handleMode(i)} />

        {mode === "vehicleExpense" && mode != "credit" && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2} sx={{ mt: 3, mb: 2 }}>
              <Grid item lg={2.3} md={6} sm={12} xs={12}>
                <MyAutoComplete
                  label="Filter by Driver"
                  title="driverName"
                  list={vehicles || []}
                  onChange={(e, val) => {
                    handleDriver(e, val);
                  }}
                />
              </Grid>
              <Grid item lg={2.3} md={6} sm={12} xs={12}>
                <MyAutoComplete
                  label="Filter by Vehicle"
                  title="vehicleName"
                  list={vehicles || []}
                  onChange={(e, val) => {
                    handleVehicle(e, val);
                  }}
                />
              </Grid>
              <Grid item lg={2.7} md={6} xs={12}>
                <DatePicker
                  label="From"
                  sx={{ width: "100%" }}
                  value={search.startDate}
                  onChange={(e) => handleDate(e, "startDate")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Grid>
              <Grid item lg={2.7} md={6} xs={12}>
                <DatePicker
                  label="To"
                  sx={{ width: "100%" }}
                  value={search.endDate}
                  onChange={(e) => handleDate(e, "endDate")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Grid>
              <Grid
                item
                lg={1}
                xs={6}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ background: "#ffffff !important", color: "#A7A7A7" }}
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Grid>
              <Grid
                item
                lg={1}
                xs={6}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Button fullWidth variant="contained">
                  Filter
                </Button>
              </Grid>
            </Grid>
          </LocalizationProvider>
        )}
        {mode !== "vehicleExpense" && mode != "credit" && (
          <>
            <Grid
              sx={{ mt: 3, alignItems: "flex-end", justifyContent: "flex-end" }}
              container
              spacing={1}
            >
              {(mode == "supplierPurchase" || mode == "customerSale" || mode == "paymentReport" ) && (
                <>
                  <Grid item lg={3} md={4} sm={12} xs={12}>
                    {mode != "supplierPurchase" || mode != "paymentReport" || mode != "sales" && (
                      <TextField
                        fullWidth
                        size="small"
                        label=""
                        placeholder="name or phone number..."
                        variant="outlined"
                        name="customerInfo"
                        value={search.customerInfo}
                        onChange={handleInput}
                        onKeyDown={(e) => {
                          if (e.key == "Enter") {
                            getCustomerSale();
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  {(mode === "supplierPurchase" || (mode !== "paymentReport" && mode !== "sales")) && (
  <Autocomplete
    size="small"
    value={state?.vendor?.companyName}
    onChange={(e, val) => {
      handleInput(e, val, "vendor");
    }}
    getOptionLabel={(option) => option.companyName || ""}
    id="controllable-states-demo"
    options={vendors}
    fullWidth
    renderInput={(params) => (
      <TextField {...params} label="Vendor" />
    )}
  />
)}

                  </Grid>
                  {(mode !== "paymentReport" && mode !== "sales") && (
                  <Grid item lg={2.2} md={4} sm={12} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label=""
                      placeholder="search item"
                      variant="outlined"
                      name="itemName"
                      value={search.itemName}
                      onKeyDown={handleKeyDown}
                      onChange={handleInput}
                    />
                  </Grid>
                  )}
                  {(mode !== "paymentReport" && mode !== "sales")  && (
                  <Grid item lg={1.8} md={4} sm={12} xs={12}>
                    <Autocomplete
                      size="small"
                      // value={state?.ledger?.name}
                      onChange={(e, val) => {
                        handleInput(e, val, "ledger");
                      }}
                      getOptionLabel={(option) => option.name || ""}
                      id="controllable-states-demo"
                      options={ledgersNames}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} label="Ledger" />
                      )}
                    />
                  </Grid>
                  )}
               {mode == "paymentReport" && (
                  <Grid item lg={1.8} md={4} sm={12} xs={12}>
                    <Autocomplete
                      size="small"
                      // value={state?.ledger?.name}
                      onChange={(e, val) => {
                        handleInput(e, val, "ledger");
                        setSelectedPaymentType(val)
                      }}
                      getOptionLabel={(option) => option || ""}
                      id="controllable-states-demo"
                      options={paymentType}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} label="Payment Type" />
                      )}
                    />
                  </Grid>
                  ) }
                </>
              )}

{mode == "employeeReport" && (
                  <Grid item lg={7.1} xs={12} >
                    <Autocomplete
                      size="small"
                      // value={state?.ledger?.name}
                      onChange={(e, val) => {
                        handleInput(e, val, "ledger");
                        setSelectedEmployee(val.username)
                      }}
                      getOptionLabel={(option) => option.username || ""}
                      id="controllable-states-demo"
                      options={employees}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} label="Employees" />
                      )}
                    />
                  </Grid>
                  ) }



{mode == "banksReport" && (
                  <Grid item lg={7.1} xs={12} >
                    <Autocomplete
                      size="small"
                      value={state?.ledger?.name}
                      onChange={(e, val) => {
                        handleInput(e, val, "ledger");
                        setSelectedBank(val)
                      }}
                      getOptionLabel={(option) => option.bankName || ""}
                      id="controllable-states-demo"
                      options={banks}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} label="Banks" />
                      )}
                    />
                  </Grid>
                  ) }

              {mode == "gatePass" && (
                <Grid item lg={7.1} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label=""
                    placeholder="search item..."
                    variant="outlined"
                    name="itemName"
                    value={search.itemName}
                    onChange={handleInput}
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        getGatePassItems();
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              )}


           

              <Grid item lg={2} md={6} sm={6} xs={12}>
                <Typography>From</Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  type="date"
                  name="startDate"
                  value={search.startDate}
                  onChange={handleSearch}
                />
              </Grid>
              <Grid item lg={2} md={6} sm={6} xs={12}>
                <Typography>To</Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  type="date"
                  name="endDate"
                  value={search.endDate}
                  onChange={handleSearch}
                />
              </Grid>
              <Grid item lg={0.9} xs={12}>
                <Button
                  fullWidth
                  sx={{ height: "40px" }}
                  variant="outlined"
                  size="small"
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>

            <AmountSection mode={mode} state={state} items={datebook} employeesReportTotalSales={employeesReportTotalSales}/>
          </>
        )}
        {mode == "credit" && <AmountSection mode={mode} state={state} />}

        <Loader loading={state.spin_loading || state.loading} />
        {!state.loading && !state.spin_loading && (
          <>
            {(mode == "sales" || mode == "salesReturn") && (
              <Sales
                mode={mode}
                items={datebook}
                onChange={(item) => handleChange(item)}
                loadMore={getMoreSales}
                loading={state.moreLoading}
             
              />
            )}
            {mode == "combinedSales" && (
              <CombinedSale
                items={datebook}
                loadMore={getMoreCombined}
                loading={state.moreLoading}
                onChange={(item) => handleChange(item)}
              />
            )}
            {mode == "purchase" && (
              <Purchase items={datebook} onChange={(i) => handleChange(i)} />
            )}
            {mode == "expense" && (
              <Expense
                items={datebook}
                onChange={(item) => handleChange(item)}
              />
            )}
            {mode == "stock" && (
              <Stock  onChange={(item) => handleChange(item)} stockReport={stockReport} />
            )}
            {mode == "purchaseReturn" && (
              <PurchaseReturn
                items={datebook}
                onChange={(i) => handleChange(i)}
              />
            )}
            {mode == "supplierPurchase" && (
              <SupplierPurchase
                items={datebook}
                onChange={(i) => handleChange(i)}
              />
            )}
            {mode == "customerSale" && (
              <CustomerSale
                items={datebook}
                onChange={(i) => handleChange(i)}
              />
            )}
            {mode == "employeeReport" && (
              <SalesByEmployee
                items={employeesReport}
                onChange={(i) => handleChange(i)}
              />
            )}
             {mode == "banksReport" && (
              <BanksDetails
                items={employeesReport}
                onChange={(i) => handleChange(i)}
              />
            )}
            {mode == "paymentReport" && (
              <PaymentReport
                items={datebook}
                onChange={(i) => handleChange(i)}
              />
            )}
            {mode == "gatePass" && (
              <GatePass items={datebook} onChange={(i) => handleChange(i)} />
            )}
            {mode == "vehicleExpense" && <VExpense data={vehicleData} />}
            {mode == "profitLoss" && (
              <ProfitLoss
                start={search.startDate}
                end={search.endDate}
                ref={printRef}
              />
            )}
            {mode == "balanceSheet" && (
              <BalanceSheet
                start={search.startDate}
                end={search.endDate}
                print={printSheet}
              />
            )}
          </>
        )}
      </BodyContainer>
    </Box>
  );
}

export default Reports;
